import qs from 'qs';
import client from './client';

const establishUrl = '/api/v1/establish';

// 부서정보 호출
export const getDeptList = () => {
  return client.get(`${establishUrl}/dept/list`);
};

export const getBudget = (year) => {
  return client.get(`${establishUrl}/budget/${year}`);
};

export const getBudgetRange = (year, startMonth, endMonth) => {
  return client.get(`${establishUrl}/budget/range/${year}`, {
    params: {
      startMonth,
      endMonth
    }
  });
};

export const setBudget = (finalData) => {
  return client.post(`${establishUrl}/budget`, finalData);
};